// extracted by mini-css-extract-plugin
export default {"linia":"OstatniaZmiana_linia__lt6uz","cofnij":"OstatniaZmiana_cofnij__zoHAh","blad":"OstatniaZmiana_blad__70icG"};